export const RememberPassword = "Remember password";
export const ForgotPassword = "Forgot password?";
export const Password = 'Password';
export const ConfirmPassword = 'Confirm Password';

export const SignIn = "Sign In";
export const SignUp = "Sign Up";
export const CreateNewAccount = 'Create a new account';
export const AlreadyHaveAccount = 'Already have an account';

export const EmailAddress = 'Email Address';
export const PhoneNumber = 'Phone Number';

export const Start = 'Start Date';
export const End = 'End Date';
export const Deal_Gallery = 'DEAL GALLERY';

